import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import cn from 'classnames';
import { getTestIds } from '../../utils/TestIds';
import styles from './MiddleEllipsis.module.scss';
import { splitForMiddleEllipsis } from './MiddleEllipsis.utils';
export const GetMiddleEllipsisTID = (parentTestId)=>getTestIds(parentTestId);
export const MiddleEllipsis = (param)=>{
    let { text, tailLength = 6, className, testId } = param;
    const { MiddleEllipsisTestIds } = useMemo(()=>GetMiddleEllipsisTID(testId), [
        testId
    ]);
    const { head, tail } = splitForMiddleEllipsis(text, tailLength);
    return /*#__PURE__*/ _jsxs("span", {
        className: cn(styles.root, className),
        title: text,
        "data-testid": MiddleEllipsisTestIds.Root(),
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: styles.text,
                "data-testid": MiddleEllipsisTestIds.Text(),
                children: text
            }),
            /*#__PURE__*/ _jsx("span", {
                className: styles.head,
                "aria-hidden": "true",
                "data-testid": MiddleEllipsisTestIds.Head(),
                children: head
            }),
            tail !== '' && /*#__PURE__*/ _jsx("span", {
                className: styles.tail,
                "aria-hidden": "true",
                "data-testid": MiddleEllipsisTestIds.Tail(),
                children: tail
            })
        ]
    });
};
